<div style="width: 100%; max-width: 800px; margin: auto;">

  <mat-card style="text-align: center;">
    <img style='width: 200px; margin: 20px auto 20px auto;' src='assets/images/geral/selo_sbccv.png'>
  </mat-card>

  <mat-card>
    <div style='text-align: center; font-size: 1.2em; padding: 20px; color: rgb(0,0,0,.6);'>
      <b>Sua resposta foi registrada com sucesso!</b>
    </div>
  </mat-card>

</div>